import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("li", {
        "data-slot": "sidebar-menu-item",
        "data-sidebar": "menu-item",
        class: _normalizeClass($setup.cn('group/menu-item relative w-full list-none', $setup.props.class))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */));
}
